import * as React from "react";
import { useMutation } from "@grandvisionhq/graphql";
import { CREATE_TICKET } from "../../operations/mutations/operations/mutations/create-ticket.js";
import { useSubmit } from "./use-submit.js";
const useCreateTicket = () => {
  const [submitData, { onSubmit, reset }] = useSubmit();
  const [createTicket, result] = useMutation(CREATE_TICKET);
  const [isSuccessful, setIsSuccessful] = React.useState(false);
  const [isSubmittable, setIsSubmittable] = React.useState(true);
  React.useEffect(() => {
    if (result.called) {
      setIsSubmittable(false);
    }
    if (result.called && result.error) {
      setIsSubmittable(true);
    }
  }, [result]);
  React.useEffect(() => {
    if (submitData && isSubmittable && submitData.recaptchaToken) {
      createTicket({ variables: { ...submitData } });
      reset();
    }
  }, [submitData, isSubmittable]);
  React.useEffect(() => {
    if (result.data?.createTicket?.success) {
      setIsSuccessful(true);
    }
  }, [result.data]);
  return [
    onSubmit,
    {
      isLoading: result.loading,
      isCalled: result.called,
      isSuccessful,
      error: result.error
    }
  ];
};
export {
  useCreateTicket
};
//# sourceMappingURL=use-create-ticket.js.map
